import supabaseClient from '@/api/supabaseClient.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

export type SendMessageParams = {
  receiver_id: string;
  content: string;
};

const useSendMessage = () => {
  const queryClient = useQueryClient();

  const mutationFn = async (params: SendMessageParams) => {
    const { data, error } = await supabaseClient.functions.invoke('send_message', {
      method: 'POST',
      body: params,
    });

    if (error) {
      if (error instanceof FunctionsHttpError) {
        const err: BackendErrorResponse = await error.context.json();
        throw new Error(err.errors.join(', '));
      }
      throw new Error((error as Error).message);
    }

    return data;
  };

  return useMutation({
    mutationFn,
    onSuccess: (_data, variables) => {
      // Invalidate messages query to refetch
      queryClient.invalidateQueries({ queryKey: ['messages', variables.receiver_id] });
      queryClient.invalidateQueries({ queryKey: ['conversations'] });
    },
  });
};

export default useSendMessage;
